export default "__VITE_ASSET__C7u8jAQz__"